import requestSender from "@/api/base/requestSender";

const UrlPrefix = "talentMatrix/";

export default function (axiosInstance) {
  return {
    matrixSearch(payload, options) {
      return requestSender('get', UrlPrefix + 'talent-matrix/search', payload, options);
    },
    matrixCreate(payload, options) {
      return requestSender('post', UrlPrefix + 'talent-matrix/create', payload, options);
    },
    matrixUpdate(payload, options) {
      return requestSender('post', UrlPrefix + 'talent-matrix/update', payload, options);
    },
    matrixDelete(payload, options) {
      return requestSender('post', UrlPrefix + 'talent-matrix/delete', payload, options);
    },
    matrixGet(payload, options) {
      return requestSender('get', UrlPrefix + 'talent-matrix/get', payload, options);
    },
    matrixCopy(payload, options) {
      return requestSender('post', UrlPrefix + 'talent-matrix/copy', payload, options);
    },

    matrixSettingUpdate(payload, options) {
      return requestSender('post', UrlPrefix + 'talent-matrix/setting-update', payload, options);
    },

    matrixCellUpdate(payload, options) {
      return requestSender('post', UrlPrefix + 'talent-matrix/cell-update', payload, options);
    },
    matrixCellPositionsUpdate(payload, options) {
      return requestSender('post', UrlPrefix + 'talent-matrix/cell-positions-update', payload, options);
    },

    matrixAxisUserValuesSearch(payload, options) {
      return requestSender('get', UrlPrefix + 'talent-matrix/axis-user-values-search', payload, options);
    },
    matrixAxisUserValuesDelete(payload, options) {
      return requestSender('post', UrlPrefix + 'talent-matrix/axis-user-values-delete', payload, options);
    },

    matrixCalculate(payload, options) {
      return requestSender('post', UrlPrefix + 'talent-matrix/matrix-calculate', payload, options);
    },
    matrixCellUserPositionsSearch(payload, options) {
      return requestSender('get', UrlPrefix + 'talent-matrix/matrix-cell-user-positions-search', payload, options);
    },

    matrixShareUsersSearch(payload, options) {
      return requestSender('get', UrlPrefix + 'talent-matrix/matrix-share-users-search', payload, options);
    },
    matrixShareUsersCreate(payload, options) {
      return requestSender('post', UrlPrefix + 'talent-matrix/matrix-share-users-create', payload, options);
    },
    matrixShareUsersDelete(payload, options) {
      return requestSender('post', UrlPrefix + 'talent-matrix/matrix-share-users-delete', payload, options);
    },
  }
}